// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-Container {
    padding: 20px;
}



.Athlete-message {
    padding-top: 10px;
}



.premium-page {}

.hero-messages {

    min-height: 1538px;
}

.content-section {
    max-width: 900px;
    /* Adjust the maximum width as needed */
    margin: 0 auto;
    /* Center the text block on the page */
    padding-top: 20px;
    margin-bottom: 40px !important;
    /* padding-left: 40px;
    padding-right: 40px; */
    /* Add some padding for breathing space */
    font-family: 'Arial', sans-serif;
    /* Choose a suitable font */
    font-size: 16px;
    /* Adjust the font size as needed */
    line-height: 1.5;
    /* Set the line height for better readability */
    color: #333;
    /* Set the text color */
    background-color: #f8f8f8dd;
    /* Set a light background color */
    border-radius: 8px;
    /* Add rounded corners */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
    /* Add a subtle box shadow */

    align-items: center;

}

.default-div {
    max-width: 900px !important;

}

.Header-hero {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 30px;
    /* font-size: 32px !important; */
}

.Athlete-message {
    width: 100% !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
    text-align: left;
}



.video-Container {

    margin: 0 auto;
}

.messages-page {

    padding-top: 50px;
    padding-bottom: 50px;
}

.video-container {

    display: flex;
    flex-wrap: wrap;
    /* gap: 80px; */
    /* justify-content: center; */

    max-width: 900px;
    position: relative;
    z-index: 1;

}

video {
    width: 100%;
}

@media (max-width: 425px) {
    .Athlete-message {
        width: 100% !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .video-Container {
        padding-top: 0px;
        display: flex;
        flex-wrap: wrap;
        padding: 0px !important;
        /* gap: 80px; */
        /* justify-content: center; */
        padding-left: 0px;
        padding-right: 0px;
        max-width: 900px;
        position: relative;
        z-index: 1;

    }

    .hero-messages {

        min-height: 538px;
        margin-left: 10px;
        margin-right: 10px;
    }

    video {
        height: auto;
        width: 100% !important;
    }

    .content-section {
        max-width: 900px;
        /* Adjust the maximum width as needed */
        margin: 0 auto;
        /* Center the text block on the page */
        padding-top: 20px;
        margin-bottom: 40px !important;
        /* padding-left: 40px;
        padding-right: 40px; */
        /* Add some padding for breathing space */
        font-family: 'Arial', sans-serif;
        /* Choose a suitable font */
        font-size: 16px;
        /* Adjust the font size as needed */
        line-height: 1.5;
        /* Set the line height for better readability */
        color: #333;
        /* Set the text color */
        background-color: #f8f8f8dd;
        /* Set a light background color */
        border-radius: 8px;
        /* Add rounded corners */
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
        /* Add a subtle box shadow */

        align-items: center;

    }

    .Header-hero {
        margin-top: 10px;
        margin-bottom: 10px;
    }
}

@media (max-width: 768px) {
    .Athlete-message {
        width: 100% !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .video-container {
        padding-top: 0px;
        display: flex;
        flex-wrap: wrap;
        /* gap: 80px; */
        /* justify-content: center; */

        max-width: 900px;
        position: relative;
        z-index: 1;

    }

    .Header-hero {
        padding-top: 0px;
    }

    .hero-messages {

        min-height: 538px;
        margin-left: 10px;
        margin-right: 10px;
    }

    video {
        height: auto;
        width: 100% !important;
    }

    .content-section {
        max-width: 900px;
        /* Adjust the maximum width as needed */
        margin: 0 auto;
        /* Center the text block on the page */
        padding-top: 20px;
        margin-bottom: 40px !important;
        /* padding-left: 40px;
        padding-right: 40px; */
        /* Add some padding for breathing space */
        font-family: 'Arial', sans-serif;
        /* Choose a suitable font */
        font-size: 16px;
        /* Adjust the font size as needed */
        line-height: 1.5;
        /* Set the line height for better readability */
        color: #333;
        /* Set the text color */
        background-color: #f8f8f8dd;
        /* Set a light background color */
        border-radius: 8px;
        /* Add rounded corners */
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
        /* Add a subtle box shadow */

        align-items: center;

    }
}`, "",{"version":3,"sources":["webpack://./src/pages/HeroMsg.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;;;AAIA;IACI,iBAAiB;AACrB;;;;AAIA,eAAe;;AAEf;;IAEI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,sCAAsC;IACtC,iBAAiB;IACjB,8BAA8B;IAC9B;0BACsB;IACtB,yCAAyC;IACzC,gCAAgC;IAChC,2BAA2B;IAC3B,eAAe;IACf,mCAAmC;IACnC,gBAAgB;IAChB,+CAA+C;IAC/C,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,uCAAuC;IACvC,4BAA4B;;IAE5B,mBAAmB;;AAEvB;;AAEA;IACI,2BAA2B;;AAE/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;AACpB;;;;AAIA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,eAAe;IACf,6BAA6B;;IAE7B,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,eAAe;QACf,uBAAuB;QACvB,eAAe;QACf,6BAA6B;QAC7B,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;;IAEd;;IAEA;;QAEI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,uCAAuC;QACvC,cAAc;QACd,sCAAsC;QACtC,iBAAiB;QACjB,8BAA8B;QAC9B;8BACsB;QACtB,yCAAyC;QACzC,gCAAgC;QAChC,2BAA2B;QAC3B,eAAe;QACf,mCAAmC;QACnC,gBAAgB;QAChB,+CAA+C;QAC/C,WAAW;QACX,uBAAuB;QACvB,2BAA2B;QAC3B,iCAAiC;QACjC,kBAAkB;QAClB,wBAAwB;QACxB,uCAAuC;QACvC,4BAA4B;;QAE5B,mBAAmB;;IAEvB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,eAAe;QACf,eAAe;QACf,6BAA6B;;QAE7B,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;;IAEd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,uCAAuC;QACvC,cAAc;QACd,sCAAsC;QACtC,iBAAiB;QACjB,8BAA8B;QAC9B;8BACsB;QACtB,yCAAyC;QACzC,gCAAgC;QAChC,2BAA2B;QAC3B,eAAe;QACf,mCAAmC;QACnC,gBAAgB;QAChB,+CAA+C;QAC/C,WAAW;QACX,uBAAuB;QACvB,2BAA2B;QAC3B,iCAAiC;QACjC,kBAAkB;QAClB,wBAAwB;QACxB,uCAAuC;QACvC,4BAA4B;;QAE5B,mBAAmB;;IAEvB;AACJ","sourcesContent":[".video-Container {\n    padding: 20px;\n}\n\n\n\n.Athlete-message {\n    padding-top: 10px;\n}\n\n\n\n.premium-page {}\n\n.hero-messages {\n\n    min-height: 1538px;\n}\n\n.content-section {\n    max-width: 900px;\n    /* Adjust the maximum width as needed */\n    margin: 0 auto;\n    /* Center the text block on the page */\n    padding-top: 20px;\n    margin-bottom: 40px !important;\n    /* padding-left: 40px;\n    padding-right: 40px; */\n    /* Add some padding for breathing space */\n    font-family: 'Arial', sans-serif;\n    /* Choose a suitable font */\n    font-size: 16px;\n    /* Adjust the font size as needed */\n    line-height: 1.5;\n    /* Set the line height for better readability */\n    color: #333;\n    /* Set the text color */\n    background-color: #f8f8f8dd;\n    /* Set a light background color */\n    border-radius: 8px;\n    /* Add rounded corners */\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);\n    /* Add a subtle box shadow */\n\n    align-items: center;\n\n}\n\n.default-div {\n    max-width: 900px !important;\n\n}\n\n.Header-hero {\n    text-align: center;\n    margin-top: 20px;\n    margin-bottom: 30px;\n    /* font-size: 32px !important; */\n}\n\n.Athlete-message {\n    width: 100% !important;\n    padding-left: 40px !important;\n    padding-right: 40px !important;\n    text-align: left;\n}\n\n\n\n.video-Container {\n\n    margin: 0 auto;\n}\n\n.messages-page {\n\n    padding-top: 50px;\n    padding-bottom: 50px;\n}\n\n.video-container {\n\n    display: flex;\n    flex-wrap: wrap;\n    /* gap: 80px; */\n    /* justify-content: center; */\n\n    max-width: 900px;\n    position: relative;\n    z-index: 1;\n\n}\n\nvideo {\n    width: 100%;\n}\n\n@media (max-width: 425px) {\n    .Athlete-message {\n        width: 100% !important;\n        padding-left: 10px !important;\n        padding-right: 10px !important;\n    }\n\n    .video-Container {\n        padding-top: 0px;\n        display: flex;\n        flex-wrap: wrap;\n        padding: 0px !important;\n        /* gap: 80px; */\n        /* justify-content: center; */\n        padding-left: 0px;\n        padding-right: 0px;\n        max-width: 900px;\n        position: relative;\n        z-index: 1;\n\n    }\n\n    .hero-messages {\n\n        min-height: 538px;\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n\n    video {\n        height: auto;\n        width: 100% !important;\n    }\n\n    .content-section {\n        max-width: 900px;\n        /* Adjust the maximum width as needed */\n        margin: 0 auto;\n        /* Center the text block on the page */\n        padding-top: 20px;\n        margin-bottom: 40px !important;\n        /* padding-left: 40px;\n        padding-right: 40px; */\n        /* Add some padding for breathing space */\n        font-family: 'Arial', sans-serif;\n        /* Choose a suitable font */\n        font-size: 16px;\n        /* Adjust the font size as needed */\n        line-height: 1.5;\n        /* Set the line height for better readability */\n        color: #333;\n        /* Set the text color */\n        background-color: #f8f8f8dd;\n        /* Set a light background color */\n        border-radius: 8px;\n        /* Add rounded corners */\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);\n        /* Add a subtle box shadow */\n\n        align-items: center;\n\n    }\n\n    .Header-hero {\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-width: 768px) {\n    .Athlete-message {\n        width: 100% !important;\n        padding-left: 10px !important;\n        padding-right: 10px !important;\n    }\n\n    .video-container {\n        padding-top: 0px;\n        display: flex;\n        flex-wrap: wrap;\n        /* gap: 80px; */\n        /* justify-content: center; */\n\n        max-width: 900px;\n        position: relative;\n        z-index: 1;\n\n    }\n\n    .Header-hero {\n        padding-top: 0px;\n    }\n\n    .hero-messages {\n\n        min-height: 538px;\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n\n    video {\n        height: auto;\n        width: 100% !important;\n    }\n\n    .content-section {\n        max-width: 900px;\n        /* Adjust the maximum width as needed */\n        margin: 0 auto;\n        /* Center the text block on the page */\n        padding-top: 20px;\n        margin-bottom: 40px !important;\n        /* padding-left: 40px;\n        padding-right: 40px; */\n        /* Add some padding for breathing space */\n        font-family: 'Arial', sans-serif;\n        /* Choose a suitable font */\n        font-size: 16px;\n        /* Adjust the font size as needed */\n        line-height: 1.5;\n        /* Set the line height for better readability */\n        color: #333;\n        /* Set the text color */\n        background-color: #f8f8f8dd;\n        /* Set a light background color */\n        border-radius: 8px;\n        /* Add rounded corners */\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);\n        /* Add a subtle box shadow */\n\n        align-items: center;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
